import '../scss/jquery.tabify.scss';

/*!
 * Tabify - A light-weight, mobile-ready and customizable tab plugin for jQuery
 *
 * Copyright 2018, Mehdi Dehghani
 *
 * @author   Mehdi Dehghani (http://www.github.com/dehghani-mehdi)
 * @license  Licensed under MIT (https://github.com/dehghani-mehdi/tabify/blob/master/LICENSE)
 *
 */
;
(function ($, window, document, undefined) {
    const pluginName = 'tabify',
        p = {};

    p[pluginName] = class {
        constructor(el, config) {
            this.el = el;
            this.$el = $(el);

            this.config = $.extend(true, {}, $.fn[pluginName].defaults, config);

            this.$caller = $(el);
            this.$headerItems = this.getCheckVisibility()
                ? this.$caller.find('> li').filter(':visible')
                : this.$caller.find('> li');
            this.$contentItems = this.getCheckVisibility()
                ? this.$caller.next().find('> li').filter(':visible')
                : this.$caller.next().find('> li');
            this.key = this.$caller.data('key');

            this.init();
        }

        init() {
            this.$caller.addClass(`tabify tabify__theme-${this.getTheme()} tabify__dir-${this.config.dir}`);
            this.activeTab(0, true);

            this.wireEvents();
        }

        wireEvents() {
            this.$headerItems.on('click', (e) => {
                let $this = $(e.currentTarget),
                    index = $this.siblings(":visible").addBack().index($this);

                if (typeof this.key !== 'undefined' && this.config.useLocalStorage) {
                    localStorage.setItem(`__tabify_${this.key}`, index);
                }

                this.$caller.trigger('onChange', index);
                if (typeof this.config.onChange === 'function') this.config.onChange.call(e, index);

                this.activeTab(index);
            });
        };

        getTheme() {
            let data = this.$caller.data('theme');

            return typeof data === 'undefined' ? this.config.theme : data;
        }

        getCheckVisibility() {
            let data = this.$caller.data('check-visibility');

            return typeof data === 'undefined' ? this.config.checkVisibility : data;
        }

        activeTab(index, isPageLoad) {
            if (isPageLoad && typeof this.config !== 'undefined') {
                if (typeof this.key !== 'undefined' && this.config.useLocalStorage) {
                    let item = localStorage.getItem(`__tabify_${this.key}`);

                    if (item !== null) index = item;
                }
            }

            this.$headerItems.removeClass('tabify__active').eq(index).addClass('tabify__active');
            this.$contentItems.removeClass('tabify__active').eq(index).addClass('tabify__active');
        }
    }

    $.fn[pluginName] = function (options) {
        return this.each(function () {
            if (!$.data(this, 'plugin_' + pluginName)) {
                $.data(this, 'plugin_' + pluginName, new p[pluginName](this, options));
            }
        });
    };

    $.fn[pluginName].defaults = {
        useLocalStorage: true,
        onChange: null,
        theme: 'default',
        dir: 'ltr',
        checkVisibility: true
    };
})(jQuery, window, document);